import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Sparkles } from 'lucide-react';
import { Button } from '../ui/button';

const HeroSection = () => {
  return (
    <section className="h-[90vh] sm:h-[95vh] relative overflow-hidden flex items-center">
      {/* Full Screen Video Background */}
      <video
        autoPlay
        loop
        muted
        playsInline
        className="absolute inset-0 w-full h-full object-cover z-0"
        poster="https://static.prod-images.emergentagent.com/jobs/685a4a49-d889-47d7-87c9-a5d959d86d4d/images/d7e81027d1684c96951ad90f2c0ac09988c0dad4ba4f7701299e636d892966cc.png"
      >
        <source 
          src="https://customer-assets.emergentagent.com/job_685a4a49-d889-47d7-87c9-a5d959d86d4d/artifacts/v2pqc5qj_GIGI%20HERO%20VIDEO%20new%20final%20compressed.mp4" 
          type="video/mp4" 
        />
        Your browser does not support the video tag.
      </video>

      {/* Dark Overlay for better text readability */}
      <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/30 z-10"></div>

      {/* Content Container */}
      <div className="max-w-7xl mx-auto px-6 sm:px-6 lg:px-8 relative z-20 w-full">
        <div className="max-w-xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-md border border-white/20 rounded-full px-3 sm:px-4 py-1.5 sm:py-2 mb-6">
            <Sparkles className="w-3 h-3 sm:w-4 sm:h-4 text-teal-400" />
            <span className="text-xs sm:text-sm font-medium text-white">Trusted by 10,000+ Patients</span>
          </div>

          {/* Heading */}
          <h1 className="text-4xl sm:text-5xl lg:text-7xl font-bold leading-tight mb-6">
            <span className="text-white">Kidney Stone</span>
            <br />
            <span className="text-white">Pain Is </span>
            <span className="text-teal-400">Real </span>
          </h1>

          {/* Description */}
          <p className="text-sm sm:text-base lg:text-lg text-gray-200 leading-relaxed sm:leading-relaxed max-w-[320px] sm:max-w-lg mb-8">
            Doktor Gigi connects you with trusted kidney specialists. Get clear, professional advice on your symptoms and treatment paths today.
          </p>

          {/* CTA Button */}
          <div className="flex flex-wrap gap-4">
            <Link to="/book-consultation">
              <Button 
                className="bg-teal-500 hover:bg-teal-400 text-white rounded-full px-8 sm:px-10 py-5 sm:py-7 text-base sm:text-lg font-semibold flex items-center gap-3 shadow-xl shadow-teal-500/30 transition-all hover:shadow-2xl hover:shadow-teal-400/40 hover:scale-105"
                data-testid="hero-cta-button"
              >
                Contact Expert Now
                <ArrowRight className="w-5 h-5 sm:w-6 sm:h-6" />
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
